import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedModule } from '../../libraries/shared.module';
import { BasicLayoutComponent } from './basic-layout.component';

@NgModule({
  imports: [
    BsDropdownModule,
    CommonModule,
    FlexLayoutModule,
    RouterModule,
    TranslateModule,
    SharedModule,
  ],
  declarations: [
    BasicLayoutComponent,
  ],
  exports: [
    BasicLayoutComponent
  ]
})
export class BasicLayoutModule { }
